import { render } from "./GestaoDeProjetos.vue?vue&type=template&id=9b7f487a"
import script from "./GestaoDeProjetos.vue?vue&type=script&lang=js"
export * from "./GestaoDeProjetos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__